import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../../application/config/config';
import Fetch from '../../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../../helpers/chooseProfileFilter';

function BankAccount() {
    const profileFilter = chooseProfileFilter();

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/people/';
    const paths = {
        endpointSave: config.endpoints.backend + 'people/save',
        endpointGetAllPeopleBankDetails:
            config.endpoints.backend + 'peoplebankdetails/getall',
        endpointGetAllBanks: config.endpoints.backend + 'banks/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleEdit: 'Editar Conta Bancária',
        labelTitleView: 'Visualizar Conta Bancária'
    };

    const hiddenValues = {};

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id;
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues,
                pdc_people_id: id,
                ...(values?.id && { id: values.id })
            },
            fields: [
                {
                    name: 'pdc_bank_id',
                    type: 'select',
                    label: 'Banco',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBanks,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'agency_number',
                    type: 'integer',
                    label: 'Número da Agência',
                    columnSize: 6,
                    validations: {
                        required: true
                    }
                },
                {
                    name: 'agency_digit',
                    type: 'text',
                    label: 'Dígito da Agência (Substitua X por 0)',
                    columnSize: 6,
                    mask: '9',
                    validations: {
                        required: true
                    }
                },
                {
                    name: 'account_number',
                    type: 'integer',
                    label: 'Número da Conta',
                    columnSize: 6,
                    validations: {
                        required: true
                    }
                },
                {
                    name: 'account_digit',
                    type: 'text',
                    label: 'Dígito da Conta (Substitua X por 0)',
                    columnSize: 6,
                    mask: '9',
                    validations: {
                        required: true
                    }
                },
            ],

            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = await Fetch.post(
                paths.endpointGetAllPeopleBankDetails,
                {
                    filter: {
                        pdc_people_id: id
                    }
                }
            );

            if (values.length === 0) {
                values = [{}];
            }

            const form = getForm(values[0]);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}
export default BankAccount;
